import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FiAlignRight,
  FiXCircle,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import "./Navbarmenu.css";
import { HashLink } from "react-router-hash-link";
import { useMsal } from "@azure/msal-react";
import { baseUrl } from "../Constant";
import axios from "axios";
const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState("c_tech");
  const [selectedStay, setSelectedStay] = useState("");
  const [selectedContact, setSelectedContact] = useState("");

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsersForContibution = [
    "aluru.akash",
    "s.rao.masipeddi",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "vanitadevi.patil",
    "aparna.a.daptardar",
  ];

  const toggleClass = () => {
    setSelectedOffer("");
    setSelectedStay("");
    setSelectedContact("");
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }
  

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }
  

  const [isMenuSubMenusecond, setMenuSubMenusecond] = useState(false);
  const toggleSubmenusecond = () => {
    setMenuSubMenusecond(isMenuSubMenusecond === false ? true : false);
  };
  let boxClassSubMenusecond = ["sub__menussecond"];
  if (isMenuSubMenusecond) {
    boxClassSubMenusecond.push("sub__menus__Activesecond");
  } else {
    boxClassSubMenusecond.push("");
  }

  const [isMenuSubMenuthird, setMenuSubMenuthird] = useState(false);
  const toggleSubmenuthird = () => {
    setMenuSubMenuthird(isMenuSubMenuthird === false ? true : false);
  };
  let boxClassSubMenuthird = ["sub__menusthird"];
  if (isMenuSubMenuthird) {
    boxClassSubMenuthird.push("sub__menus__Activethird");
  } else {
    boxClassSubMenuthird.push("");
  }

  const [isMenuSubMenufourth, setMenuSubMenufourth] = useState(false);
  const toggleSubmenufourth = () => {
    setMenuSubMenufourth(isMenuSubMenufourth === false ? true : false);
  };
  let boxClassSubMenufourth = ["sub__menusfourth"];
  if (isMenuSubMenufourth) {
    boxClassSubMenufourth.push("sub__menus__Activefourth");
  } else {
    boxClassSubMenufourth.push("");
  }

  const [temp,setTemp] =useState("");
  useEffect(()=>{
    const homeurl = async() =>{
      const result = await axios.get(`${baseUrl}/homeUrl`)
      const {data:{Url}} = result

      setTemp(Url)
    }
    homeurl()
  },[]);

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="header__middle__menus">
          <nav className="main-nav ">
            {/* Responsive Menu Button */}
            {isResponsiveclose === true ? (
              <>
                <span role="button" tabIndex={0} aria-haspopup="true" aria-expanded="false" type="button"
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  {" "}
                  <FiXCircle />{" "}
                </span>
              </>
            ) : (
              <>
                <span role="button" tabIndex={0} aria-haspopup="true" aria-expanded="false" type="button"
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  {" "}
                  <FiAlignRight />{" "}
                </span>
              </>
            )}
            <ul className={boxClass.join(" ")}>
            <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href={temp?temp:""}
                    target="_blank"
                  >
                    <span>L&TT Home</span>
                  </a>
                </li>
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/newhome"
                >
                  {" "}
                  Home{" "}
                </NavLink>{" "}
              </li>                                                        
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
